<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p>对账单编号：</p>
        <el-input v-model='queryForm.settNo' size='mini' style='width:150px'
                  placeholder='请输入对账单编号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>对账单标题：</p>
        <el-input v-model='queryForm.title' size='mini' style='width:150px'
                  placeholder='请输入对账单标题' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>公司名称：</p>
        <el-input v-model='queryForm.companyNameNew' size='mini' style='width:150px'
                  placeholder='请输入公司名称' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>类型：</p>
        <el-select v-model='queryForm.type' filterable size='mini' style='width:150px'
                   placeholder='请选择类型'>
          <el-option v-for='item in typeOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>结算方式：</p>
        <el-select v-model='queryForm.settType' filterable size='mini' style='width:150px'
                   placeholder='请选择结算方式'>
          <el-option v-for='item in settTypeOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableData'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{
           color: '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          background: '#E8E8E8'
          }"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column label='对账单编号' prop='settNo' align='center' show-overflow-tooltip />
          <el-table-column label='标题' prop='title' align='center' show-overflow-tooltip />
          <el-table-column label='公司名称' align='center' show-overflow-tooltip width='240px'>
            <div slot-scope='scope' style='display:flex;align-items:center;justify-content:center'>
              {{ scope.row.companyNameNew }}
              <!-- 判断委托商是否 与原委托商相同  不同则展示         -->
              <el-tooltip v-if='scope.row.companyNameNew !==scope.row.companyNameOld'
                          :content='`原结算单位：${scope.row.companyNameOld}`' placement='bottom'
                          effect='light'>
                <img v-if='scope.row.companyNameOld' alt=''
                     :src="require('@/assets/images/warnning.png')" />
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column label='对账单类型' min-width='120' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.type | accountType }}
            </template>
          </el-table-column>
          <el-table-column label='结算方式' prop='createTime' min-width='120' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? '合同价' : scope.row.settType === 2 ?'预结算价':'合同价/预结算价' }}
            </template>
          </el-table-column>
          <el-table-column label='税率' prop='taxRate' align='center' show-overflow-tooltip />
          <el-table-column label='含税费用' min-width='110' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? scope.row.taxPrice : scope.row.taxSettPrice }}
            </template>
          </el-table-column>
          <el-table-column label='不含税费用' min-width='110' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? scope.row.noTaxPrice : scope.row.noTaxSettPrice }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='205' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;padding-left: 10px'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id,scope.row.type)'>详情
                </el-button>
                <el-button v-if='scope.row.choise === 1' size='mini'
                           type='primary' @click='auditClick(scope.row.id,1)'>同意
                </el-button>
                <el-button v-if='scope.row.choise === 1' size='mini'
                           type='danger' @click='auditClick(scope.row.id,0)'>拒绝
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <!-- 详情对话框 start -->
    <el-dialog title='详情' :visible.sync='detailDialogVisible' :width='detailDialogWidth'
               @close='detailClose' center top='10vh'>
      <div class='detail'>
        <el-tabs v-model='activeName'>
          <el-tab-pane label='基础信息' name='first'>
            <div class='baseInfo'>
              <div class='baseInfoContent'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>对账单编号：</span>
                  <span>{{ detailData.settNo }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>标题：</span>
                  <span>{{ detailData.title }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>委托商：</span>
                  <span>{{ detailData.companyNameOld }}</span>
                  <el-tooltip v-if='detailData.companyNameOld != detailData.companyNameNew'
                              placement='bottom' effect='light'>
                    <div slot='content'>
                      <span style='color: #999;'>原委托商名称：{{ detailData.companyNameNew }}</span>
                    </div>
                    <i class='el-icon-warning'
                       style='color: red;font-size: 18px;margin-right: 5px;' />
                  </el-tooltip>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>结算方式：</span>
                  <span v-show='detailData.settType===1'>合同价</span>
                  <span v-show='detailData.settType===2'>预结算价</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>合计含税费用：</span>
                    <span>{{ (detailData.settType === 1 ? detailData.taxPrice : detailData.taxSettPrice)
                    || 0 }}元</span>
                    <el-tooltip placement='bottom' effect='light'>
                      <div slot='content'>
                        <span style='color: #999;'>
                          结算费用{{ (detailData.settType === 1 ? detailData.taxPrice : detailData.taxSettPrice) || 0
                          }}元
                        </span><br />
                        <span style='color: #999;'>
                          其他结算费用
                          {{ (detailData.settType === 1 ? detailData.noTaxPrice : detailData.noTaxSettPrice) || 0
                          }}元
                        </span><br />
                      </div>
                      <i class='el-icon-warning'
                         style='color: red;font-size: 18px;margin-right: 5px;' />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class='span1'>合计不含税费用：</span>
                    <span>{{ (detailData.settType === 1 ? detailData.noTaxPrice : detailData.noTaxSettPrice) || 0
                      }}元</span>
                  </div>
                </div>
                <!--                <div class="baseInfoContentItem">-->
                <!--                  <span class="span1">生成对账单时间：</span>-->
                <!--                  <span>{{detailData.time2}}</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div class='operation' v-if='detailData.isDeduct==1'>
              <div class='operationTitle'>
                <div class='line' />
                <span>抵扣对账单</span>
              </div>
              <div class='operationTable'>
                <el-table :data='detailData.table1' border>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='operateType' label='对账单编号' align='center' />
                  <el-table-column prop='operationName' label='抵扣费用' align='center' />
                </el-table>
              </div>
            </div>
            <div class='baseInfo' v-if='detailData.status==1'>
              <div class='baseInfoTitle'>
                <div class='line' />
                <span>审核信息</span>
              </div>
              <div>
                <steps :step-data='stepData' :step-state='stepState' />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='结算费用' name='second'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0;'>
                <el-table
                  :data='detailTable'
                  border
                  script
                >
                  <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='brandName' label='品牌' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='modelName' label='型号' align='center'
                                   show-overflow-tooltip />
                  <!--                  <el-table-column prop='departurePlace' label='起始地' min-width='150' align='center'
                                                     show-overflow-tooltip>
                                      <template slot-scope='scope'>
                                        {{
                                          scope.row.departurePlaceType == 1 ? scope.row.departurePlace : scope.row.departurePort
                                        }}
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop='arrivePlace' label='交车地' min-width='150' align='center'
                                                     show-overflow-tooltip>
                                      <template slot-scope='scope'>
                                        {{
                                          scope.row.arrivePlaceType == 1 ?
                                            scope.row.arrivePlace : scope.row.arrivePort
                                        }}
                                      </template>
                                    </el-table-column>-->
                  <el-table-column prop='standingBookMonth' label='台账月' min-width='100'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-if='settlement === 1 || settlement === 3' prop='taxContractPrice' label='含税合同价'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-if='settlement === 2 || settlement === 3' prop='taxPreparePrice' label='含税预结算价' align='center'
                                   show-overflow-tooltip />
                  <el-table-column v-if='settlement === 1 || settlement === 3' prop='contractPrice' label='不含税合同价'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-if='settlement === 2 || settlement === 3' prop='preparePrice' label='不含税预结算价' align='center'
                                   show-overflow-tooltip />
                </el-table>
              </div>
              <div class='paginationContainer'
                   style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal }}条</span>
                <el-pagination
                  background
                  :page-sizes='[10, 20, 30, 40]'
                  layout='sizes,prev, pager, next,jumper'
                  :total='detailTotal'
                  @size-change='detailSizeChange'
                  @current-change='detailCurrentChange'
                  @prev-click='detailCurrentChange'
                  @next-click='detailCurrentChange'
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='其它结算费用' name='third'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0'>
                <el-table
                  :data='detailTable3'
                  border
                  script
                >
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='costNum' label='费用编号' align='center' />
                  <el-table-column prop='costTypeName' label='费用类型' align='center' />
                  <el-table-column prop='costInstruction' label='费用说明' align='center' />
                  <el-table-column prop='costTime' label='费用时间' align='center' />
                  <el-table-column prop='taxRate' label='税率(%)' align='center' />
                  <el-table-column prop='costAmount' label='含税价' align='center' />
                  <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />
                </el-table>
              </div>
              <div class='paginationContainer'
                   style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal3 }}条</span>
                <el-pagination
                  background
                  :page-sizes='[10, 20, 30, 40]'
                  layout='sizes,prev, pager, next,jumper'
                  :total='detailTotal3'
                  @size-change='detail3SizeChange'
                  @current-change='detail3CurrentChange'
                  @prev-click='detail3CurrentChange'
                  @next-click='detail3CurrentChange'
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='开票信息'
                       v-if='detailData.status!=0&&detailData.status!=1&&detailData.status!=2'
                       name='fourth'>
            <div class='baseInfo'>
              <div class='baseInfoContent' style='padding: 0'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>是否抵扣开票：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>抵扣开票费用编号：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>原开票金额：</span>
                    <span>{{ detailData.customerNatureName }}</span>
                  </div>
                  <div>
                    <span class='span1'>抵扣金额：</span>
                    <span>{{ detailData.customerScaleName }}</span>
                  </div>
                </div>
              </div>
              <div class='operationTable' style='margin-top:0'>
                <el-table
                  :data='detailTable2'
                  border
                  script
                >
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='type' label='发票号码' align='center' />
                  <el-table-column prop='remark2' label='发票金额' align='center' />
                  <el-table-column prop='batch' label='发票日期' align='center' />
                  <el-table-column prop='rate' label='发票类型' align='center' />
                  <el-table-column prop='price' label='发票税率' align='center' />
                  <el-table-column prop='price2' label='核销期限' align='center' />
                  <el-table-column prop='remark' label='创建日期' align='center' />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 详情对话框 end -->

    <!-- 审核原因 -->
    <el-dialog :title='reasonTitle' :visible.sync='reasonVisible' width='550px' center
               :close-on-click-modal='false' top='30vh'>
      <div class='reasonContainer'>
        <div style='display: flex;padding-bottom: 20px;'>
          <span class='span1' style='width: 70px;'><span style='color:red'>*</span>原因：</span>
          <el-input
            type='textarea'
            style='width:100%;'
            v-model='reason'
            placeholder='请填写同意/拒绝原因'
            autocomplete='off'
            size='small'
          />
        </div>
        <div class='reasonBtn'>
          <el-button size='medium' class='searchBtn' type='primary' @click='reasonClick'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' type='danger' @click='reasonVisible=false'>取消
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps.vue';
  import { formatDateTime } from '@/config/mUtils';
  import {
    getStatementAuditList,
    AccountDetail,
    accountDelete, getStatementAuditInfo, getPageListSCFI, getPageListSOCI, postStatementAudit,
  } from '@/service/getData';

  export default {
    components: {
      steps,
    },
    data() {
      return {
        activeName: 'first',
        settTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '合同价',
          },
          {
            value: 2,
            label: '预结算价',
          },
        ],
        typeOption: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '委托商运费',
            value: 1,
          },
          {
            label: '委托商港口费',
            value: 2,
          },
          {
            label: '公路供应商托运费',
            value: 4,
          },
          {
            label: '水路供应商运费',
            value: 5,
          },
          {
            label: '港口供应商操作费',
            value: 6,
          },
          {
            label: '港口供应商燃油费',
            value: 7,
          },
          {
            label: '港口堆存费',
            value: 8,
          },
          {
            label: '提车费',
            value: 9,
          },
          {
            label: '委托商港口库房费',
            value: 13,
          },
          {
            label: '供应商港口库房费',
            value: 14,
          },
        ],
        total: 0,
        tableLoad: false,
        TableData: [],
        detailDialogVisible: false,
        detailDialogWidth: '1050px',
        detailTable: [],
        detailTotal: 0,
        detailSize: 10,
        detailPage: 1,
        detailTable2: [],
        detailTable3: [],
        detailTotal3: 0,
        detailSize3: 10,
        detailPage3: 1,
        detailData: {},
        stepData: [],
        basicId: 0,
        basicType: 0,
        settlement: 1,// 结算方式 1：合同价 2：预结算价
        reasonVisible: false,
        reasonTitle: '',
        reason: '',
        queryForm: {
          settNo: '',
          title: '',
          companyNameNew: '',
          type: '',
          settType: '',
          page: 1,
          rows: 10,
        },
      };
    },
    watch: {
      activeName(val) {
        if (val === 'second') {
          this.getPageListSCFI();
        } else if (val === 'third') {
          this.getPageListSOCI();
        }
      },
    },
    filters: {
      accountType(value) {
        let returnStr = '';
        switch (value) {
          case 1:
            returnStr = '委托商运费';
            break;
          case 2:
            returnStr = '委托商港口费';
            break;
          case 4:
            returnStr = '公路供应商托运费';
            break;
          case 5:
            returnStr = '水路供应商运费';
            break;
          case 6:
            returnStr = '港口供应商操作费';
            break;
          case 7:
            returnStr = '港口供应商燃油费';
            break;
          case 8:
            returnStr = '港口堆存费';
            break;
          case 9:
            returnStr = '提车费';
            break;
          case 13:
            returnStr = '委托商港口库房费';
            break;
          case 14:
            returnStr = '供应商港口库房费';
            break;
          default:
            returnStr = '--';
            break;
        }
        return returnStr;
      },
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
    },
    mounted() {
      this.getStatementAuditList();
    },
    methods: {
      async getStatementAuditList() {
        this.tableLoad = true;
        const res = await getStatementAuditList(this.queryForm);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.methods);
        this.total = res.data.total;
        this.TableData = res.data.records;
        console.log(this.TableData, '表单数据');
      },
      // 主页面条数
      contractSizeChange(sizes) {
        this.queryForm.rows = sizes;
        this.getStatementAuditList();
      },
      // 主页面页数
      contractCurrentChange(page) {
        this.queryForm.page = page;
        this.getStatementAuditList();
      },
      detailClose() {
        this.detailDialogVisible = false;
        this.activeName = 'first';
      },
      async detailClick(id, type) {
        this.basicType = type;
        const {
          status,
          data,
          message,
        } = await getStatementAuditInfo(id);

        if (status === 0) {
          this.basicId = id;
          this.detailDialogVisible = true;
          this.settlement = data.settType;
          this.detailData = data;
          if (data.auditRecordList) {
            this.stepData = [];
            // 审核信息数据
            data.auditRecordList.forEach(res => {
              const str = this.strFormat(res.status);
              const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : '';
              this.stepData.push({
                title: res.auditorName + str,
                time: res.createTime,
                state,
                remark: res.opinion,
              });
            });
          }
        } else {
          this.$message.warning(message);
        }
      },
      searchBtn() {
        this.queryForm.page = 1;
        this.getStatementAuditList();
      },
      resetBtn() {
        this.queryForm = {
          settNo: '',
          title: '',
          companyNameNew: '',
          type: '',
          settType: '',
          page: 1,
          rows: 10,
        };
      },
      // 结算费用条数
      detailSizeChange(size) {
        this.detailSize = size;
        this.getPageListSCFI();
      },
      // 结算费用页数
      detailCurrentChange(page) {
        this.detailPage = page;
        this.getPageListSCFI();
      },
      // 其他结算费用条数
      detail3SizeChange(size) {
        this.detailSize3 = size;
        this.getPageListSOCI();
      },
      // 其他结算费用页数
      detail3CurrentChange(page) {
        this.detailPage3 = page;
        this.getPageListSOCI();
      },
      async getPageListSCFI() {
        const {
          status,
          message,
          data: {
            records,
            total,
          },
        } = await getPageListSCFI({
          id: this.basicId,
          page: this.detailPage,
          rows: this.detailSize,
          type: this.basicType,
        });
        if (status === 0) {
          this.detailTable = records;
          this.detailTotal = total;
        } else {
          this.$message.warning(message);
        }
      },
      async getPageListSOCI() {
        const {
          status,
          message,
          data: {
            records,
            total,
          },
        } = await getPageListSOCI({
          id: this.basicId,
          page: this.detailPage3,
          rows: this.detailSize3,
        });
        if (status === 0) {
          this.detailTable3 = records;
          this.detailTotal3 = total;
        } else {
          this.$message.warning(message);
        }
      },
      // 格式化审核信息状态
      strFormat(val) {
        let returnStr = '';
        switch (val) {
          case 0:
            returnStr = ' 重新发起';
            break;
          case 1:
            returnStr = ' 发起';
            break;
          case 2:
            returnStr = ' 同意';
            break;
          case 3:
            returnStr = ' 拒绝';
            break;
          case 4:
            returnStr = ' 取消审核';
            break;
          default:
            returnStr = '';
            break;
        }
        return returnStr;
      },
      auditClick(id, type) {
        this.$confirm(`确认${type ? '同意' : '拒绝'}当前审核吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.basicId = id;
            this.reason = '';
            type ? this.reasonTitle = '同意原因' : this.reasonTitle = '拒绝原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      async reasonClick() {
        this.reason = this.reason.trim();
        if (!this.reason) return this.$message.warning(this.reasonTitle === '同意原因' ? '请填写同意原因！' : '请填写拒绝原因!');
        const {
          status,
          message,
        } = await postStatementAudit({
          id: this.basicId,
          auditOpinion: this.reason,
          reviewResult: this.reasonTitle === '同意原因' ? 'AGREE' : 'REFUSE',
        });
        if (status !== 0) return this.$message.error(message);
        this.$message.success(message);
        this.reasonVisible = false;
        await this.getStatementAuditList();
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 90px;
        text-align: right;
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            /*display: none;*/
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #F56C6C !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;

          &Nav {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .addCost {
      display: flex;
      flex-direction: column;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      &Table {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox:after {
            color: rgb(127, 127, 127);
            content: "全选";
            font-size: 12px;
            font-weight: 700;
            //margin-left: 2px;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox {
            margin-left: 8px;
          }

          .el-checkbox {
            margin-left: 16px;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Table {
        margin-bottom: 25px;
        width: 100%;

        .tableAddBtnContainer {
          border: 1px solid #EBEEF5;;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #F59A23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
